import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, Validators, FormControl } from '@angular/forms';

@Component({
    selector: 'app-edit-parking-lot-link',
    templateUrl: './edit-parking-lot-link.component.html',
    styleUrls: ['./edit-parking-lot-link.component.scss'],
    standalone: false
})
export class EditParkingLotLinkComponent extends ModelEditor implements OnInit {
  public originalTotal: number = 0;

  constructor(
    private apiService: ApiServiceBase,
    private injector: Injector,
    protected route: ActivatedRoute,
    protected override router: Router,
    protected override toast: ToastrService
  ) {
    super(`infrastructure/parkinglots/${route.snapshot.params['lotid']}/links`, injector, 'id');
  }

  public get parkingLot1Control(): FormControl {
    return this.Form.get('ParkingLot1TotalSpaces') as FormControl;
  }

  public get parkingLot2Control(): FormControl {
    return this.Form.get('ParkingLot2TotalSpaces') as FormControl;
  }

  public override DefaultModel(): any {
    return {
      ParkingLot1TotalSpaces: 0,
      ParkingLot2TotalSpaces: 0,
      IsAllocationAdjustable: false
    };
  }

  public override AfterModelLoaded(): void {
    this.originalTotal = this.Model.ParkingLot1TotalSpaces + this.Model.ParkingLot2TotalSpaces;
  }

  public override Validators(): any {
    return {
      'ParkingLot1TotalSpaces': [Validators.required, Validators.min(0), Validators.max(this.originalTotal)],
      'ParkingLot2TotalSpaces': [Validators.required, Validators.min(0), Validators.max(this.originalTotal)]
    };
  }

  public onSpaceAllocationChange(event: any, index: number) {
    const value = parseInt(event.target.value);
    if (index === 0) {
      this.Form.patchValue({
        ParkingLot1TotalSpaces: value,
        ParkingLot2TotalSpaces: this.originalTotal - value
      });
    } else {
      this.Form.patchValue({
        ParkingLot2TotalSpaces: value,
        ParkingLot1TotalSpaces: this.originalTotal - value
      });
    }
  }

  public onNumberInputChange(event: any, index: number) {
    const value = parseInt(event.target.value);
    if (isNaN(value)) return;
    
    if (index === 0) {
      this.Form.patchValue({
        ParkingLot1TotalSpaces: value,
        ParkingLot2TotalSpaces: this.originalTotal - value
      });
    } else {
      this.Form.patchValue({
        ParkingLot2TotalSpaces: value,
        ParkingLot1TotalSpaces: this.originalTotal - value
      });
    }
  }

  public override BeforeSave(): void {
    // Ensure the total spaces match the original total
    const total = this.Form.get('ParkingLot1TotalSpaces')?.value + this.Form.get('ParkingLot2TotalSpaces')?.value;
    if (total !== this.originalTotal) {
      this.toast.error('Total spaces must equal the original total', 'Error');
      return;
    }
  }
} 
